
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stud/[parent]",
      function () {
        return require("private-next-pages/stud/[parent]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stud/[parent]"])
      });
    }
  